import React, { useEffect,useRef, useState } from 'react';
import classnames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import * as PropTypes from 'prop-types';

import { useInnerWidth } from 'hooks';
import { scrollTo } from 'utils';

import MoreItemsDropdown from './MoreItemsDropdown';

import subHeaderStyles from '../../../css/subHeader.module.css';

const Tab = ({ isCurrentPage, title, link, options }) => {
  const { isHash, onClick } = options;
  const linkClassName = `tab-list-item ${isCurrentPage ? 'tab-list-active' : ''}`;

  if (isHash || isCurrentPage) {
    return (
      <p className={linkClassName} onClick={() => (isHash ? scrollTo(link, 550) : null)}>
        {title}
      </p>
    );
  }

  if (onClick) {
    return (
      <a className={linkClassName} onClick={onClick}>
        {title}
      </a>
    );
  }

  return (
    <a href={link} className={linkClassName}>
      {title}
    </a>
  );
};

Tab.propTypes = {
  isCurrentPage: PropTypes.bool,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  options: PropTypes.object,
  callout: PropTypes.any,
  centered: PropTypes.bool,
  backNavigation: PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string,
    clickHandler: PropTypes.func,
  }),
};

Tab.defaultProps = {
  isCurrentPage: false,
  options: {},
  callout: null,
  centered: false,
  backNavigation: {},
};

const maxSubheaderItemsSize = 10;

const resolutionForMobileCallout = 1199;

const SubHeader = ({ subheaderItems = [], callout, className, centered, backNavigation }) => {
  const innerWidth = useInnerWidth();

  const [leftArrow, setLeftArrow] = useState(false);

  const [rightArrow, setRightArrow] = useState(true);

  const [moreItemsDropdown, setMoreItemsDropdown] = useState(
    innerWidth <= resolutionForMobileCallout ? false : subheaderItems.length > maxSubheaderItemsSize
  );

  const clusterRef = useRef(false);

  const scrollEnabled = subheaderItems?.length > 3;

  useEffect(() => {
    checkArrows();
    setMoreItemsDropdown(
      innerWidth <= resolutionForMobileCallout
        ? false
        : subheaderItems.length > maxSubheaderItemsSize
    );
  }, [moreItemsDropdown]);

  // Checks left and right arrow
  function checkArrows() {
    if (clusterRef.current && scrollEnabled) {
      const maxScrollLeft = clusterRef.current.scrollWidth - clusterRef.current.clientWidth;
      setLeftArrow(clusterRef.current.scrollLeft > 0);
      setRightArrow(
        maxScrollLeft > 1 ? !(maxScrollLeft < clusterRef.current.scrollLeft + 1) : false
      );
    }
  }

  /**
   *
   * @param {Object} element Container Tab Element
   * @param {Boolean} right Whether to scroll right or left
   */
  function handleSlideSubmenu(element, right) {
    const sl = element.current.scrollLeft;
    const cw = element.current.scrollWidth;
    const increment = 300;

    if (right) {
      if (sl + increment >= cw) {
        element.current.scrollTo(cw, 0);
      } else {
        element.current.scrollTo(sl + increment, 0);
      }
    } else {
      if (sl - increment <= 0) {
        element.current.scrollTo(0, 0);
      } else {
        element.current.scrollTo(sl - increment, 0);
      }
    }
    checkArrows();
  }

  return (
    <div
      id="navigation"
      className={classnames('cluster-subheader navbar-tabs', {
        'with-callout': callout,
        [className]: className,
      })}
    >
      <div
        className={classnames('tabs-container container', {
          'd-flex align-items-center centered': centered,
        })}
      >
        {!_isEmpty(backNavigation) && (
          <div className="goBack py-0 flex-1">
            {backNavigation.link ? (
              <a href={backNavigation.link}>
                <span>{backNavigation.title}</span>
              </a>
            ) : (
              <span onClick={backNavigation.clickHandler}>{backNavigation.title}</span>
            )}
          </div>
        )}
        <div
          className={classnames('subheaders-links-container', {
            'd-none d-md-flex': !_isEmpty(backNavigation),
            'overflow-visible': !scrollEnabled,
          })}
          ref={clusterRef}
          onScroll={checkArrows}
        >
          {leftArrow && scrollEnabled && (
            <div
              onClick={() => handleSlideSubmenu(clusterRef)}
              className={classnames(subHeaderStyles.submenuArrow, subHeaderStyles.submenuArrowLeft)}
            >
              <i className={subHeaderStyles.submenuArrowIcon} aria-hidden="true" />
            </div>
          )}
          {subheaderItems
            .slice(0, moreItemsDropdown ? maxSubheaderItemsSize : subheaderItems.length)
            .map((item) => {
              return (
                <Tab
                  key={item.title}
                  isCurrentPage={item.isCurrentPage}
                  link={item.link}
                  title={item.title}
                  options={item.options}
                />
              );
            })}

          <div className="d-none d-xl-block">
            {moreItemsDropdown && (
              <MoreItemsDropdown items={subheaderItems.slice(maxSubheaderItemsSize)} />
            )}
          </div>

          {rightArrow && scrollEnabled && (
            <div
              onClick={() => handleSlideSubmenu(clusterRef, true)}
              className={classnames(
                subHeaderStyles.submenuArrow,
                subHeaderStyles.submenuArrowRight
              )}
            >
              <i className={subHeaderStyles.submenuArrowIcon} aria-hidden="true" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
